import { captureException } from "@web-monorepo/telemetry";

const HEARTBEAT_INTERVAL_MS = 50_000;

export type HeartbeatPublish = (topic: string, data: Record<string, unknown>) => void;

export function startHeartbeat(publish: HeartbeatPublish, tutorUid: string): () => void {
  const topic = `user.${tutorUid}.presence.marketplace-tutors`;

  function sendHeartbeat() {
    // Defer to a microtask so any synchronous throw from `publish` (e.g.
    // NATS.js transport-level TypeError) becomes a promise rejection routed
    // to captureException instead of propagating up. `startHeartbeat()` is
    // called from inside the SNTS store's `connect()`, so an uncaught throw
    // here would propagate out of `connect()` to its caller — dropping the
    // subsequent `logTutorEvent("marketplace.nats.connection")` and turning a
    // background telemetry failure into a user-visible connection failure.
    Promise.resolve()
      .then(() => publish(topic, {}))
      .catch((err: unknown) => captureException(err));
  }

  sendHeartbeat();
  let intervalId: ReturnType<typeof setInterval> | null = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

  function handleVisibilityChange() {
    if (document.hidden) {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    } else {
      if (intervalId === null) {
        sendHeartbeat();
        intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
      }
    }
  }

  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}
